import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MsalServiceService } from './msal-service.service';

@Injectable({
  providedIn: 'root'
})
export class MsalAuthGuard implements CanActivate {
  constructor(private router : Router, private msalServiceService: MsalServiceService){}
  canActivate(){
    if(this.msalServiceService.isAuthenticated()) {
      return true;
    } else {
      this.router.navigate(['/home']);
    }
  }
  
}
